// extracted by mini-css-extract-plugin
export var infoItem = "_oo-2";
export var title = "_oo-0";
export var value = "_oo-1";